import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { LoaderService } from './core/services/loader.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  loading$: Observable<boolean>;
  constructor(
    private primengConfig: PrimeNGConfig,
    private loaderService: LoaderService
  ) {
    this.loading$ = this.loaderService.loading$;
  }

  ngOnInit() {
    this.primengConfig.ripple = true;
  }
}
